import IconButton from '@material-ui/core/IconButton'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from '@material-ui/icons/Delete'
import React from 'react'
import { toastr } from 'react-redux-toastr'
import { CircularProgress } from '@material-ui/core'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    formControl: {
        margin: theme.spacing.unit,
        width: 250
    },
    button: {
        margin: theme.spacing.unit
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class RoomTab extends React.Component {
    handleDelete = id => {
        const toastrConfirmOptions = {
            onOk: () => this.props.onDelete(id)
        }
        toastr.confirm('Вы уверены, что хотите удалить маппинг?', toastrConfirmOptions)
    }

    render() {
        const { rooms, classes, fetching, fields } = this.props

        if (fetching) return <CircularProgress className={classes.progress} />

        return (
            <Paper className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {fields.map(item => <TableCell key={item.label}>{item.label}</TableCell>)}
                            <TableCell>Действие</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rooms.map((item, i) => (
                            <TableRow hover key={item.remoteId + '-' + i}>
                                {fields.map(el => <TableCell key={item[el.key]}>{item[el.key]}</TableCell>)}
                                <TableCell>
                                    <IconButton aria-label="Delete" onClick={() => this.handleDelete(item.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Paper>
        )
    }
}

export default withStyles(styles)(RoomTab)



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/RoomsTab/RoomsTab.js